import { Data } from 'signup-constants/signupData/Data';
import { getSignupDataGtkmData } from '../store/signup-data/selectors';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { Tracker } from '../store/tracking/action-creators';
import { isAssignedToGTKMExperiment } from '../utils/gtkm/isAssignedToGTKM';
export const trackGTKMDataChanged = ({
  dispatch,
  state
}) => {
  const companyDomain = getSignupDataValue(state, Data.CompanyDomain);
  const gtkmCompanyDomain = getSignupDataGtkmData(state, Data.CompanyDomain);
  const companyName = getSignupDataValue(state, Data.CompanyName);
  const gtkmCompanyName = getSignupDataGtkmData(state, Data.CompanyName);
  const industry = getSignupDataValue(state, Data.Industry);
  const gtkmIndustry = getSignupDataGtkmData(state, Data.Industry);
  const companySize = getSignupDataValue(state, Data.CompanySize);
  const gtkmCompanySize = getSignupDataGtkmData(state, Data.CompanySize);
  const isAssignedToGTKM = isAssignedToGTKMExperiment(state);
  if (!isAssignedToGTKM) return;
  const hasGTKMDomainChanged = companyDomain && companyDomain !== gtkmCompanyDomain;
  const hasGTKMCompanyNameChanged = companyName && companyName !== gtkmCompanyName;
  const hasGTKMIndustryChanged = industry && industry !== gtkmIndustry;
  const hasGTKMCompanySizeChanged = companySize && companySize !== gtkmCompanySize;
  dispatch(Tracker.signupInteraction(`has-gtkm-domain-changed`, {
    currentValue: hasGTKMDomainChanged
  }));
  dispatch(Tracker.signupInteraction(`has-gtkm-company-name-changed`, {
    currentValue: hasGTKMCompanyNameChanged
  }));
  dispatch(Tracker.signupInteraction(`has-gtkm-industry-changed`, {
    currentValue: hasGTKMIndustryChanged
  }));
  dispatch(Tracker.signupInteraction(`has-gtkm-company-size-changed`, {
    currentValue: hasGTKMCompanySizeChanged
  }));
};